// extracted by mini-css-extract-plugin
export default {"wordmark":"Wordmark_wordmark__3haQT","wrapper":"Wordmark_wrapper__TMi9d"};